<template>
  <div id="navbar-main" :class="lodgePage ? 'lodge-page-navphone' : 'navphone-default'">
<!--    <div class="top-bar">-->
<!--      <i class="fa-solid fa-gift" style="margin-right: 5px;"></i>-->
<!--      <span>-10% sur votre 1er séjour</span>-->
<!--    </div>-->
    <div class="top-bar" v-if="promotionMessage">
      <i class="fa-solid fa-gift" style="margin-right: 5px;"></i>
      <span @click="showModal = true" style="text-align: center;" v-html="promotionMessage"></span>
    </div>
    <div id="nav-phone" :class="(currentRoute == '/') ? 'homenav' : ''">
      <Modalsignup v-if="showModal" @close="setUser"></Modalsignup>
      <div class="nav-phone" :class="lodgePage ? 'pb-3' : ''">
        <a href="/" class="logo" v-if="!showBanner">
          <img v-if="lodgePage" src="../../images/Logo hortense.svg" v-set-alt>
          <img v-else src="../../images/hortense blanc.svg" v-set-alt>
        </a>
        <div v-if="shownavphone" style="z-index:9999999;position:relative">
          <!-- <SearchbtnPhoneWhite v-if="!showBanner" @show="showBanner = !showBanner"></SearchbtnPhoneWhite> -->
        </div>
        <div class="nav-phone-actions">
          <PageTranslator class="page-translator"></PageTranslator>
          <Burger :user="user"></Burger>
        </div>
      </div>
      <div v-if="shownavphone">
        <SearchbannerPhone v-if="showBanner" @close="showBanner = false"></SearchbannerPhone>
      </div>
    </div>
  </div>
</template>

<script>

  import Burger from 'components/menus/Burger.vue';
  import Modalsignup from 'components/modals/Modalsignup.vue';
  import SearchbtnPhoneWhite from 'components/btns/SearchbtnPhoneWhite.vue';
  import SearchbannerPhone from 'components/btns/SearchbannerPhone.vue';
  import PageTranslator from 'components/shared/PageTranslator.vue';
  import fetcher from 'packs/shared/api.js';

  export default{
    name: 'nav-main-phone',
    props: ["user", "shownavphone", "lodgePage"],
    components: { Burger, Modalsignup, SearchbannerPhone, SearchbtnPhoneWhite, PageTranslator},
    data() {
      return {
        search: "",
        currentRoute: window.location.pathname,
        showModal: false,
        showBanner: false,
        promotionMessage: null,

      }
    },
    methods:{
      setUser(user){
        this.user = user;
        this.showModal = false;
      },
      async updatePromotionMessage() {
      const pathParts = window.location.pathname.split('/');

      if (pathParts[1] === 'reservation-hotel' && pathParts[2]) {
        const slug = pathParts[2];
        try {
          const response = await fetcher.get(`/lodging/${slug}/banner_message`);
          const msg = response?.data?.message;
          if (msg && msg.trim() !== '') {
            this.promotionMessage = msg;
            return;
          }
        } catch (e) {
          console.error("Error fetching banner message:", e.message);
        }
      }
    },
    },
    mounted() {
      this.updatePromotionMessage();
      this.$root.$on('openModal', _ => {
        this.showModal = true;
      });
    },
  }
</script>

<style lang="scss" scope='app/assets/stylesheets/components/nav-phone'>
  .top-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: auto !important;
    font-size: 14px;
    color: white;
    background: #1c1c1c;
    position: fixed;
    top: 0;
    z-index: 100;
    padding: 10px;
  }

  .nav-phone-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .lodge-page-navphone {
    .bm-burger-bars {
      background-color: #000 !important;
      border: .5px solid black !important;
    }
  }
</style>

<style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    .page-translator {
      position: absolute;
      top: 40%;
      right: 22%;
    } 
    .nav-phone {
      margin-top: 15px !important;
    }
  }
</style>

<style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    .nav-phone {
      margin-top: 15px !important;
    }
  }
</style>
